import { render } from "./LetterSenderForm.vue?vue&type=template&id=d600d440"
import script from "./LetterSenderForm.vue?vue&type=script&lang=js"
export * from "./LetterSenderForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__